import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

const VALUES = [
    {
        title: 'Simple',
        text: 'Encontrar, reservar o publicar espacio de almacén no debería ser un trámite interminable. Reunimos búsqueda, contratación, pagos y operación diaria en una sola plataforma.',
    },
    {
        title: 'Digital',
        text: 'Desde la reservación hasta los movimientos de entrada y salida de mercancía, todo se gestiona en línea: menos papeleo, más visibilidad y control en tiempo real.',
    },
    {
        title: 'Confiable',
        text: 'Verificamos documentos, centralizamos los pagos por transferencia SPEI y damos seguimiento a cada reservación para que clientes y anfitriones operen con respaldo.',
    },
];

const FAQ_BLOCKS = [
    {
        question: '¿Qué es PalletCloud?',
        answer:
            'Somos la plataforma digital para rentar y publicar espacios de almacén industrial en México. Conectamos a quienes necesitan guardar mercancía con quienes tienen capacidad disponible, de forma simple, digital y confiable.',
    },
    {
        question: '¿Qué hacemos?',
        answer:
            'Facilitamos la renta de posiciones de pallet y espacios de almacenaje en todo el país. Los clientes buscan por ubicación, fechas, tipo de almacenaje y servicios; los anfitriones publican su capacidad con fotos, precios, políticas de cancelación y disponibilidad.',
    },
    {
        question: '¿Cómo se gestiona una reservación?',
        answer:
            'Con una sola cuenta puedes alternar entre Modo Cliente y Modo Anfitrión. El pago se realiza por transferencia SPEI, con seguimiento de reservaciones, calificaciones, mensajes con soporte y movimientos de entrada y salida para ingresar o retirar mercancía.',
    },
];

const FOR_WHO = [
    {
        title: 'Para clientes',
        text: 'Empresas que necesitan espacio de almacenaje por día, semana, mes o año. Encuentran almacenes cerca, comparan precios y reservan con transferencia SPEI.',
        link: { to: '/', label: 'Explorar almacenes' },
        variant: 'primary',
    },
    {
        title: 'Para anfitriones',
        text: 'Dueños y operadores de almacenes que quieren monetizar capacidad ociosa. Publican espacios, aprueban solicitudes y gestionan reservaciones desde el Modo Anfitrión.',
        link: { to: '/unirte', label: 'Publicar tu almacén' },
        variant: 'secondary',
    },
];

const About = () => (
    <div className="aboutPage">
        <section className="aboutHero">
            <p className="aboutHero__kicker">Compañía</p>
            <h1>Acerca de PalletCloud</h1>
            <p className="aboutHero__lead">
                Renta de almacenes industriales en México — simple, digital y confiable.
            </p>
        </section>

        <section className="aboutFaq" aria-label="Información sobre PalletCloud">
            {FAQ_BLOCKS.map((item) => (
                <article key={item.question} className="aboutFaq__item">
                    <h2 className="aboutQuestion">{item.question}</h2>
                    <p>{item.answer}</p>
                </article>
            ))}
        </section>

        <section className="aboutGrid" aria-label="Nuestros valores">
            {VALUES.map((item) => (
                <article key={item.title} className="aboutCard">
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                </article>
            ))}
        </section>

        <section className="aboutSplit">
            {FOR_WHO.map((item) => (
                <article key={item.title} className="aboutSplit__item">
                    <h2 className="aboutSplit__title">{item.title}</h2>
                    <p>{item.text}</p>
                    <Link
                        to={item.link.to}
                        className={`aboutBtn aboutBtn--${item.variant}`}
                    >
                        {item.link.label}
                    </Link>
                </article>
            ))}
        </section>

        <section className="aboutCta">
            <div>
                <h2 className="aboutQuestion aboutQuestion--light">¿Tienes dudas?</h2>
                <p>
                    Revisa las preguntas frecuentes o escríbenos desde Mensajes. Estamos para ayudarte
                    a encontrar espacio o a publicar el tuyo.
                </p>
            </div>
            <div className="aboutCta__actions">
                <Link to="/faqs" className="aboutCta__primary">Ver FAQs</Link>
                <Link to="/faqs#contacto" className="aboutCta__ghost">Contactar soporte</Link>
            </div>
        </section>
    </div>
);

export default About;
